import { useEffect, useState } from "react"
import { ClientInfo } from "../types"
import { getToken } from "providers/A12n"
import decodeToken from "jwt-decode"

type UserInfo = {
  gmp_user?: {
    assignedBrand: string
    assignedClients: ClientInfo[]
  }
}

export function useGetUserInfo() {
  const [userInfo, setUserInfo] = useState<UserInfo>()

  useEffect(() => {
    getToken().then((res) => {
      setUserInfo(decodeToken(res!))
    })
  }, [])

  return {
    isGmpUser: !!userInfo?.gmp_user,
    assignedClients: userInfo?.gmp_user?.assignedClients,
    assignedBrand: userInfo?.gmp_user?.assignedBrand,
  }
}
